(function () {
var $c519d076f6352209$exports = {};
function $c519d076f6352209$var$addLocalPath(path) {
    if (window.location.host !== "localhost:1234") return path;
    return path + ".html";
}
function $c519d076f6352209$var$getLangLink(pageName) {
    const pagePath = window.location.pathname;
    const partToPaste = pagePath.includes("ru") ? "ru" : pagePath.includes("en") ? "en" : "";
    if (!partToPaste) return $c519d076f6352209$var$addLocalPath(`./${pageName}`);
    return $c519d076f6352209$var$addLocalPath(`./${partToPaste}-${pageName}`);
}
function $c519d076f6352209$var$redirectToPage(pageName) {
    document.location.href = $c519d076f6352209$var$getLangLink(pageName);
}
function $c519d076f6352209$var$goToTri() {
    $c519d076f6352209$var$redirectToPage("triathlon");
}
function $c519d076f6352209$var$goToRun() {
    $c519d076f6352209$var$redirectToPage("run");
}
const $c519d076f6352209$var$triThumb = document.querySelector(".tri-link");
const $c519d076f6352209$var$runThumb = document.querySelector(".run-link");
const $c519d076f6352209$var$heroBlock = document.querySelector(".hero");
const $c519d076f6352209$var$arrowsBlock = document.querySelector(".hero__choose");
let $c519d076f6352209$var$scalePlus = 50;
let $c519d076f6352209$var$scaleMinus = 50;
if (window.screen.width <= 768) {
    const screenHight = document.documentElement.clientHeight;
    let neededHeightForRedirect = (screenHight - 72) * 0.9; //90% of client height - header
    const basicBlockHeight = (screenHight - 72) / 2;
    const endFnc = (e)=>{
        let thumbTri = $c519d076f6352209$var$triThumb.getBoundingClientRect();
        let thumbRun = $c519d076f6352209$var$runThumb.getBoundingClientRect();
        if (thumbTri.height > thumbRun.height) $c519d076f6352209$var$goToTri();
        else if (thumbRun.height > thumbTri.height) $c519d076f6352209$var$goToRun();
        else console.log(e.target);
        $c519d076f6352209$var$triThumb.style.height = null;
        $c519d076f6352209$var$runThumb.style.height = null;
        $c519d076f6352209$var$arrowsBlock.style = null;
        return;
    };
    $c519d076f6352209$var$heroBlock.addEventListener("touchstart", ()=>{
        $c519d076f6352209$var$heroBlock.addEventListener("touchend", endFnc);
    }, true);
    let startY;
    let arrowBasicY;
    $c519d076f6352209$var$heroBlock.addEventListener("touchstart", (e)=>{
        startY = e.touches[0].clientY;
        arrowBasicY = $c519d076f6352209$var$arrowsBlock.getBoundingClientRect().y;
    }, true);
    $c519d076f6352209$var$heroBlock.addEventListener("touchmove", (e)=>{
        let currentY = e.touches[0].clientY;
        let difference = currentY - startY;
        $c519d076f6352209$var$triThumb.style.height = `${basicBlockHeight + difference}px`;
        $c519d076f6352209$var$runThumb.style.height = `${basicBlockHeight - difference}px`;
        $c519d076f6352209$var$arrowsBlock.style.top = `${arrowBasicY + difference + 7}px`;
    }, true);
    $c519d076f6352209$var$triThumb.addEventListener("click", $c519d076f6352209$var$goToTri);
    $c519d076f6352209$var$runThumb.addEventListener("click", $c519d076f6352209$var$goToRun);
} else {
    $c519d076f6352209$var$triThumb.addEventListener("click", $c519d076f6352209$var$goToTri);
    $c519d076f6352209$var$runThumb.addEventListener("click", $c519d076f6352209$var$goToRun);
}

})();
//# sourceMappingURL=en.c8ec4733.js.map
